import gsap from 'gsap';

export default function initAccordion() {
  const classActive = 'is-open';
  const mediaQuery = window.matchMedia('(max-width: 1023px)');
  const accordionsMobile = [];

  function setupMobile(item) {
    item.card.classList.remove(classActive);
    item.trigger.removeAttribute('tabindex');
    item.trigger.removeAttribute('aria-hidden');
    item.trigger.setAttribute('aria-expanded', 'false');
    item.panel.setAttribute('aria-hidden', 'true');
    item.panel.setAttribute('inert', '');
    gsap.killTweensOf(item.panel);
    gsap.set(item.panel, { height: 0, overflow: 'hidden' });
  }

  function setupDesktop(item) {
    item.card.classList.remove(classActive);
    item.trigger.setAttribute('tabindex', '-1');
    item.trigger.setAttribute('aria-hidden', 'true');
    item.trigger.removeAttribute('aria-expanded');
    item.panel.removeAttribute('aria-hidden');
    item.panel.removeAttribute('inert');
    gsap.killTweensOf(item.panel);
    gsap.set(item.panel, { clearProps: 'all' });
  }

  function openItem(item) {
    item.card.classList.add(classActive);
    item.trigger.setAttribute('aria-expanded', 'true');
    item.panel.removeAttribute('inert');
    item.panel.setAttribute('aria-hidden', 'false');

    gsap.killTweensOf(item.panel);
    gsap.fromTo(item.panel,
      { height: 0, overflow: 'hidden' },
      { height: 'auto', duration: 0.4, clearProps: 'height,overflow' }
    );
  }

  function closeItem(item) {
    item.card.classList.remove(classActive);
    gsap.killTweensOf(item.panel);
    gsap.set(item.panel, { height: item.panel.scrollHeight, overflow: 'hidden' });
    gsap.to(item.panel, { height: 0, duration: 0.4, onComplete() {
      item.trigger.setAttribute('aria-expanded', 'false');
      item.panel.setAttribute('aria-hidden', 'true');
      item.panel.setAttribute('inert', '');
    }});
  }

  const toOpenFirst = [];

  document.querySelectorAll('[data-accordion]').forEach(accordion => {
    const mobileOnly = accordion.hasAttribute('data-mobile-only');
    const items = [];
    let prevItem = null;

    accordion.querySelectorAll('[data-accordion-item]').forEach(card => {
      const trigger = card.querySelector('[data-opener]');
      const panel = card.querySelector('[data-slide]');
      if (!trigger || !panel) return;

      const item = { card, trigger, panel };
      items.push(item);

      trigger.addEventListener('click', () => {
        if (mobileOnly && !mediaQuery.matches) return;

        if (card.classList.contains(classActive)) {
          closeItem(item);
          prevItem = null;
        } else {
          if (prevItem) closeItem(prevItem);
          prevItem = item;
          openItem(item);
        }
      });
    });

    if (mobileOnly) {
      accordionsMobile.push({ items, resetPrev: () => { prevItem = null; }, setPrev: v => { prevItem = v; } });
    } else {
      items.forEach(item => setupMobile(item));
    }

    if (items[0]) {
      toOpenFirst.push({ item: items[0], mobileOnly, setPrev: v => { prevItem = v; } });
    }
  });

  accordionsMobile.forEach(({ items }) => {
    items.forEach(item => mediaQuery.matches ? setupMobile(item) : setupDesktop(item));
  });

  toOpenFirst.forEach(({ item, mobileOnly, setPrev }) => {
    if (mobileOnly && !mediaQuery.matches) return;
    openItem(item);
    setPrev(item);
  });

  mediaQuery.addEventListener('change', e => {
    accordionsMobile.forEach(({ items, resetPrev, setPrev }) => {
      resetPrev();
      items.forEach(item => e.matches ? setupMobile(item) : setupDesktop(item));
      if (e.matches && items[0]) {
        openItem(items[0]);
        setPrev(items[0]);
      }
    });
  });
}
